var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRetailMainDataIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.998,
    viewBox: "0 0 18 17.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "retail_main_date_icon",
    "data-name": "retail main date icon",
    d: "M-5870.491,19268a.625.625,0,0,1-.619-.625v-2.818a2.09,2.09,0,0,0,.251.02,1.851,1.851,0,0,0,.638-.111v1.76h4.444v-1.76a1.886,1.886,0,0,0,.633.111,2.09,2.09,0,0,0,.251-.02v2.818a.622.622,0,0,1-.619.625Zm-9.758-.943a1.762,1.762,0,0,1-1.388-.668,1.577,1.577,0,0,1-.324-1.348,8.087,8.087,0,0,1,5.218-5.943,5.042,5.042,0,0,1-1.954-3.98,5.171,5.171,0,0,1,5.218-5.115c.218,0,.43.014.633.033a5.216,5.216,0,0,1,4.531,4.289,5.07,5.07,0,0,1-1.635,4.561h-2.625l-1.257,3.293-.029.082a2.7,2.7,0,0,0-.141.852,2.772,2.772,0,0,0,.89,2.021v1.924Zm13.97-3.84-.348-2.33h1.828l.764,2a.681.681,0,0,1,.034.223,1.042,1.042,0,0,1-1.142.889A1.083,1.083,0,0,1-5866.279,19263.217Zm-2.863-.105v-.059l.228-2.166h1.828l.228,2.172v.053a1.039,1.039,0,0,1-1.142.889A1.039,1.039,0,0,1-5869.142,19263.111Zm-2.858,0a.681.681,0,0,1,.034-.223l.764-2h1.828l-.348,2.336a1.085,1.085,0,0,1-1.136.777A1.042,1.042,0,0,1-5872,19263.111Z",
    transform: "translate(5882 -19250.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRetailMainDataIn);
export default __webpack_public_path__ + "static/media/menu_retail_main_data_in.1f5aa47e68ccb3873b0c88e6d9701a28.svg";
export { ForwardRef as ReactComponent };